import { combineReducers } from 'redux';
import AuthReducer from './AuthReducer';
import StepReducer from './StepReducer';
import SpecsReducer from './SpecsReducer';
import ItemReducer from './ItemReducer';
import BuildingAreaReducer from './specReducers/BuildingAreaReducer';
import CategoryReducer from './specReducers/CategoryReducer';
import SubCategoryReducer from './specReducers/SubCategoryReducer';
import MaterialDetailReducer from './specReducers/MaterialDetailReducer';
import MaterialCatReducer from './specReducers/MaterialCatReducer';
import BuildingNumberReducer from './specReducers/BuildingNumberReducer';
import ClassificationReducer from './specReducers/ClassificationReducer';
import CountryReducer from './specReducers/CountryReducer';
import CurrencyReducer from './specReducers/CurrencyReducer';
import GeoAreaReducer from './specReducers/GeoAreaReducer';
import LanguageReducer from './specReducers/LanguageReducer';
import LocationNameReducer from './specReducers/LocationNameReducer';
import SubjectReducer from './specReducers/SubjectReducer';
import SurfaceReducer from './specReducers/SurfaceReducer';
import TechnologyReducer from './specReducers/TechnologyReducer';
import ObjectNumReducer from './specReducers/ObjectNumReducer';
import ConditionCategoryReducer from './specReducers/ConditionCategoryReducer';
import ConditionReportReducer from './ConditionReportReducer';
import TreatmentCategoryReducer from './specReducers/TreatmentCategoryReducer';
import MoveReasonReducer from './specReducers/MoveReasonReducer';
import ObjMoveReportReducer from './ObjMoveReportReducer';
import TreatmentReportReducer from './TreatmentReportReducer';
import UserReducer from './UserReducer';
import SummaryReducer from './SummaryReducer';
import FilterReducer from './FilterReducer';
import ActivityReducer from './ActivityReducer';
import PoiReducer from './cmsReducers/PoiReducer';
import NewsReducer from './cmsReducers/NewsReducer';
import AppSettingsReducer from './cmsReducers/AppSettingsReducer';
import CmsLanguageReducer from './cmsReducers/CmsLanguageReducer';
import BeaconReducer from './cmsReducers/BeaconReducer';
import PoiGroupReducer from './cmsReducers/PoiGroupReducer';

export default combineReducers({
  auth: AuthReducer,
  step: StepReducer,
  specsTree: SpecsReducer,
  item: ItemReducer,
  buildingAreaReducer: BuildingAreaReducer,
  categoryReducer: CategoryReducer,
  subcategoryReducer: SubCategoryReducer,
  materialDetailReducer: MaterialDetailReducer,
  materialCatReducer: MaterialCatReducer,
  buildingNumberReducer: BuildingNumberReducer,
  classificationReducer: ClassificationReducer,
  countryReducer: CountryReducer,
  currencyReducer: CurrencyReducer,
  geoAreaReducer: GeoAreaReducer,
  languageReducer: LanguageReducer,
  locationNameReducer: LocationNameReducer,
  subjectReducer: SubjectReducer,
  surfaceReducer: SurfaceReducer,
  technologyReducer: TechnologyReducer,
  objectNumReducer: ObjectNumReducer,
  conditionReportReducer: ConditionReportReducer,
  treatmentReportReducer: TreatmentReportReducer,
  conditionCatReducer: ConditionCategoryReducer,
  treatmentCatReducer: TreatmentCategoryReducer,
  movementReasonReducer: MoveReasonReducer,
  objectMovementReportReducer: ObjMoveReportReducer,
  userReducer: UserReducer,
  summaryReducer: SummaryReducer,
  filterReducer: FilterReducer,
  activityReducer: ActivityReducer,
  poiReducer: PoiReducer,
  newsReducer: NewsReducer,
  appSettingsReducer: AppSettingsReducer,
  cmsLanguageReducer: CmsLanguageReducer,
  beaconReducer: BeaconReducer,
  poiGroupReducer: PoiGroupReducer,
});
